export type SurveyCsvMetaID = "createdAt" | "answerId";
export type SurveyCsvMetaField = {
  id: SurveyCsvMetaID;
  name: string;
  description?: string;
};

export const csvMetaFields: SurveyCsvMetaField[] = [
  {
    id: "answerId",
    name: "回答ID",
    description: "アンケートの回答ごとに採番する固有のIDです。",
  },
  {
    id: "createdAt",
    name: "回答日時",
  },
] as const;

export const isSurveyCsvMetaField = (
  value: unknown,
): value is SurveyCsvMetaID => {
  switch (value) {
    case "createdAt":
    case "answerId":
      return true;
    default:
      return false;
  }
};
